import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import PickMantra from './views/PickMantra.vue'
import SendMessage from './views/SendMessage.vue'

Vue.use(Router)

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: Home,
      children: [
        { path: '/start=1', redirect: '/' },
        {
          path: '',
          name: 'landing',
          component: () => import(/* webpackChunkName: "landing" */ './components/Landing_Landing.vue'),
          meta: {
            title: 'unlock your heart',
            section: 'get started'
          }
        },
        {
          path: 'learn-how',
          name: 'learn-how',
          component: () => import(/* webpackChunkName: "learnHow" */ './components/Landing_LearnHow.vue'),
          meta: {
            title: 'learn how',
            section: 'get started'
          }
        },
        {
          path: 'get-started',
          name: 'get-started',
          component: () => import(/* webpackChunkName: "getStarted" */ './components/Landing_GetStarted.vue'),
          meta: {
            title: 'get started',
            section: 'get started'
          }
        }
      ]
    },
    {
      path: '/send-message/:mantraId',
      component: SendMessage,
      children: [
        {
          path: ':resource',
          name: 'send-message',
          component: () => import(/* webpackChunkName: "sendMessage" */ './views/SendMessage.vue'),
          meta: {
            title: 'customize it',
            section: 'pick a mantra'
          }
        }
      ]
    },
    {
      path: '/pick-a-mantra',
      component: PickMantra,
      children: [
        {
          path: '',
          name: 'mantra-format',
          component: () => import(/* webpackChunkName: "pickMantra" */ './components/Mantra_Format.vue'),
          meta: {
            title: 'pick a mantra format',
            section: 'pick a mantra format'
          }
        },
        {
          path: ':resource',
          name: 'mantras',
          component: () => import(/* webpackChunkName: "TextMantraFormat" */ './components/Mantra_Container.vue'),
          meta: {
            title: 'pick a mantra',
            section: 'pick a mantra'
          }
        }
      ]
    },
    {
      path: '/share',
      name: 'share',
      component: () => import(/* webpackChunkName: "pickMantra" */ './views/Share.vue'),
      meta: {
        title: 'share a message',
        section: 'share a message'
      }
    },
    {
      path: '/next-steps',
      name: 'next-steps',
      component: () => import(/* webpackChunkName: "pickMantra" */ './views/NextSteps.vue'),
      meta: {
        title: 'next steps',
        section: 'next steps'
      }
    },
    {
      path: '/preview/:mantraId',
      name: 'preview',
      component: () => import(/* webpackChunkName: "sendMessage" */ './views/Preview.vue'),
      meta: {
        title: 'screenshot',
        section: 'preview'
      }
    }
  ],
  // eslint-disable-next-line
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
